import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { TuiScrollbar } from '@taiga-ui/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { CarouselService } from './services';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent extends BaseResizableComponent implements AfterViewInit, OnChanges {
  @ViewChild(TuiScrollbar, { read: ElementRef }) private scrollBar?: ElementRef<HTMLElement>;
  @Input() loading = true;

  carouselService = new CarouselService('horizontal', 450, this.cdr);

  ngAfterViewInit(): void {
    this.setScrollElement();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading && !this.loading) {
      this.setScrollElement();
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();

    this.carouselService.destroy();
  }

  private setScrollElement() {
    if (this.scrollBar) {
      this.carouselService.setScrollElement(this.scrollBar.nativeElement);
    }
  }
}
